import React, { useEffect, useState } from "react";
import { Alert } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { Dialog, DialogActions, DialogContent, Typography, Divider, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SplitPaymentIcon from '../../../../../assets/svg/splitPayment/splitPaymentIcon.svg'
import CustomButton from "../../../../reusableComponents/CustomButton";
import './splitPayment.css'
import CustomToggleButton from "../../../../reusableComponents/CustomRadioButtons/CustomToggleButton";
import useDynamicFields from "../../../../customHooks/useDynamicFields";
import PaymentDynamicForm from "./PaymentDynamicForm";
import { useAuth } from "../../../../context/API_Client";
import { customToast } from "../../../../reusableComponents/customToaster/customToast";
import { formatAmount } from "../../../utils/utils";

const SPLIT_PAYMENT_INITIAL_STATE = { partner: "", partnerAmount: "", commission: "" }
export default function SplitPaymentModal({ toggleDialog, updateToggleDialog, totalAmount, currencyCode, transactionID, getTimeLine }) {
    const [selected, setSelected] = useState("FIXED");
    const [remainingAmount, setRemainingAmount] = useState(0)
    const [error, setError] = useState('')
    const [partnerList, setPartnerList] = useState([])
    const [submitLoader, setSubmitLoader] = useState(false)
    const { getSubMerchants, addSplitPaymentData } = useAuth()
    const paymentDynamicField = useDynamicFields(SPLIT_PAYMENT_INITIAL_STATE);

    const handleChange = (newValue) => {
        if (newValue !== null) {
            setSelected(newValue);
            paymentDynamicField.resetFields()
            setError("")
            setRemainingAmount(totalAmount)
        }
    };

    const options = [
        { value: "FIXED", label: "Flat Amount" },
        { value: "PERCENTAGE", label: "Percentage %" },
    ];

    const handleSubmitSettlement = () => {
        const splitSettlementInstructions = paymentDynamicField?.fields?.map(({ partner, commission, partnerAmount }) => {
            const payload = {
                subMerchantId: partner,
                subMerchantSettlementReference: uuidv4(),
                subMerchantSettlement: { amount: partnerAmount || 0, currencyCode },
                merchantSettlement: { amount: commission || 0, currencyCode }
            }
            return payload
        });
        setSubmitLoader(true)
        const finalPayload = { splitSettlementType: selected, splitSettlementInstructions };
        addSplitPaymentData(transactionID, finalPayload, (data) => {
            setSubmitLoader(false)
            if (data?.status?.toLowerCase() == "failed") customToast("success", 'high', data.message)
            updateToggleDialog(false)
            getTimeLine()
        }, (err) => {
            setSubmitLoader(false)
            customToast("error", "high", err || "Something Went Wrong")
        })
    };

    const isButtonDisabled = () => {
        let isAllFieldsAreCorrect = paymentDynamicField?.fields?.every(({ partner, partnerAmount, commission }) => {
            if (!partner) return false;
            const amountZero = Number(partnerAmount) === 0;
            const commissionZero = Number(commission) === 0;
            return !(amountZero && commissionZero) && (amountZero || commissionZero || (partnerAmount > 0 && commission > 0));
        });
        return remainingAmount || error || !isAllFieldsAreCorrect
    }

    useEffect(() => {
        getSubMerchants({}, (data) => {
            if (data?.points?.length) {
                const formattedPartneredList = data.points.map(el => ({ title: el.merchantName, value: el.subMerchantId }))
                setPartnerList(formattedPartneredList)
            }
        }, () => { })
    }, [])

    useEffect(() => {
        setRemainingAmount(totalAmount)
    }, [totalAmount])
    return (
        <Dialog
            open={toggleDialog}
            PaperProps={{
                style: {
                    backgroundColor: "#FFF",
                    borderRadius: "12px",
                    width: "822px",
                    maxWidth: "822px",
                    minHeight: "533px",
                    display: "flex",
                    justifyContent: "space-between",
                },
            }}
        >
            <div >
                {" "}
                <div className="card-header" style={{ padding: "24px 24px 0 24px" }}>
                    <div className="card-header-content">
                        <div className="card-header-content-top">
                            <div className="d-flex align-items-center " style={{ gap: "10px" }}>
                                <SplitPaymentIcon style={{ color: "black" }} />
                                <Typography className="SemiboldTwenty">
                                    Split Settlement
                                </Typography>
                            </div>
                            <CloseIcon
                                sx={{ width: "24px", height: "36px" }}
                                className="icon"
                                onClick={() => updateToggleDialog(false)}
                            />
                        </div>

                    </div>
                </div>
                <DialogContent className="card-content">
                    <div style={{ padding: "0 24px" }}>
                        <div className="mt-1 mb-2">
                            <Divider />
                        </div>
                        <div className="d-flex justify-content-between p-2">
                            <div style={{ width: "47%" }}>
                                <Typography className="labelRegular" style={{ color: "var(--global-neutral-grey-1100, #2D2B32)", marginBottom: 8 }}>
                                    Total Order Amount
                                </Typography>
                                <Typography className="paymentTotalAmount" >
                                    {currencyCode} {formatAmount({ amount: totalAmount })}
                                </Typography>
                                <div className="mt-3">
                                    <Typography className="labelRegular" style={{ color: "var(--global-neutral-grey-1100, #2D2B32)", marginBottom: 8 }}>
                                        Select Amount Type*
                                    </Typography>
                                    <div className="d-flex align-items-center justify-content-between" >
                                        <CustomToggleButton options={options} value={selected} onChange={handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "47%" }}>
                                <Typography className="labelRegular" style={{ color: "#9E5707", marginBottom: 8 }}>
                                    Amount Remaining
                                </Typography>
                                <Typography className="paymentTotalAmount" >
                                    {currencyCode} {formatAmount({ amount: remainingAmount?.toFixed(2) })}
                                </Typography>
                                {selected == "PERCENTAGE" && <div style={{ marginTop: "15px" }}>
                                    <Alert
                                        style={{
                                            backgroundColor: "#FEFFE6",
                                            padding: 1,
                                            display: "inline-block",
                                            marginTop: "6px",
                                            "& .MuiAlert-message": {
                                                padding: 0,
                                            },
                                        }}
                                        icon={false}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "3px", padding: "0 5px" }}>
                                            <img src="/assets/info-circle-yellow.svg" />
                                            <div>
                                                <Typography style={{ color: " var(--Global-Neutral-Grey-1300, #0A090B)", fontSize: "12px", fontWeight: 400, textAlign: "left", }}>
                                                    Percentage is calculated on the total order amount.
                                                </Typography>
                                            </div>
                                        </div>
                                    </Alert>
                                </div>}
                            </div>
                        </div>

                    </div>
                    <div className="mt-2 mb-2">
                        <Divider />
                    </div>
                    <div style={{ padding: "0 24px" }} className="mt-2">
                        <div className="d-flex align-items-center " style={{ gap: "20px" }}>
                            <Typography className="labelSemiBold mb-2" style={{ color: "#01010299", margin: "0", minWidth: "180px", width: "40%" }}>
                                Partner
                            </Typography>
                            <Typography className="labelSemiBold mb-2" style={{ color: "#01010299", margin: "0", minWidth: "160px", width: "20%" }}>
                                Partner Amount
                            </Typography>
                            <Typography className="labelSemiBold mb-2" style={{ color: "#01010299", margin: "0", minWidth: "160px", width: "20%" }}>
                                Commission
                            </Typography>
                        </div>
                        {totalAmount > 0 && < div className="partnerFormContainer">
                            <PaymentDynamicForm partnerList={partnerList} paymentDynamicField={paymentDynamicField} selectedType={selected} totalPaymentAmount={totalAmount} error={error} setError={setError} setRemainingAmount={setRemainingAmount} initialState={SPLIT_PAYMENT_INITIAL_STATE} />
                        </div>}
                    </div>

                </DialogContent>
            </div >

            <DialogActions className="card-footer" sx={{ padding: "0px" }}>
                <CustomButton text={"Cancel"} variant={"outlined"} type={"secondary"} disabled={submitLoader} onClick={() => updateToggleDialog(false)} />
                <CustomButton loading={submitLoader} text={"Add Settlement"} variant={"contained"} disabled={isButtonDisabled()} onClick={handleSubmitSettlement} type={"secondary"} />
            </DialogActions>
        </Dialog >
    );

}
